import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import AddCarPriorityGroup from './AddCarPriorityGroup'

function CarPriorityTimes(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }
  const removeData = async (index, group) => {
    try {
      await axios.delete(`${SERVER_URI}/delete_car_priority_group/${props.carPriorityList[index].group}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
    } catch (e) {
      console.log('Error in deleting car priority group', e)
    }
    props.dispatch({
      type: 'DELETE_CAR_PRIORITY_GROUP',
      data: { carPriorityGroupIndex: index },
    })
    props.dispatch({
      type: 'DELETE_PRIORITY_GROUP_FROM_VEHICLES',
      data: group,
    })
  }

  return (
    <div className='configurations'>
      {isOpen && <AddCarPriorityGroup dispatch={props.dispatch} handleClose={togglePopUp} />}
      <h3>Autojen prioriteettiryhmät</h3>
      <span>
        <div className='discountRates'>
          <button id='lightBlue_button' onClick={togglePopUp}>
            Lisää ryhmä{' '}
          </button>
          {(props.carPriorityList === undefined) | (props.carPriorityList.length === 0) ? (
            <h4>Ei prioriteettiryhmiä</h4>
          ) : (
            <table id='carPriorityTable'>
              <thead>
                <tr>
                  <th>Ryhmän nimi</th>
                  <th>Ilmoituksen viivästys</th>
                </tr>
              </thead>
              <tbody>
                {props.carPriorityList
                  .sort((a, b) => (a.delayTime > b.delayTime ? 1 : b.delayTime > a.delayTime ? -1 : 0))
                  .map((carPriorityGroup, index) => (
                    <tr key={index} id={carPriorityGroup.group}>
                      <td>{carPriorityGroup.group}</td>
                      <td>{Number(carPriorityGroup.delayTime)} min</td>
                      <td className='opration'>
                        <button onClick={() => removeData(index, carPriorityGroup.group)}>Poista</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </span>
    </div>
  )
}

export default CarPriorityTimes
